import React from "react";
import { TextField, SimpleShowLayout } from "react-admin";
import Grid from "@mui/material/Grid";
import {
  raLabeledStyle,
  raSimpleShowLayoutFlexRow,
  raSimpleShowLayoutCellFlex,
} from "../../../../customStyles/ra-custom-styles";

export const DistrictsFirstReference = () => {
  return (
    <Grid
      container
      spacing={3}
    >
      <Grid
        item
        xs={12}
        md={4}
        lg={4}
      >
        <SimpleShowLayout
          sx={{
            "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
            "& .RaLabeled-label": raLabeledStyle,
          }}
        >
          <TextField
            label="Издател"
            source="publisher_name"
          />
          <TextField
            label="Аб.камп."
            source="campaign_name"
          />
        </SimpleShowLayout>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
        lg={4}
      >
        <SimpleShowLayout
          sx={{
            "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
            "& .RaLabeled-label": raLabeledStyle,
          }}
        >
          <TextField
            label="Област"
            source="district"
          />
          <TextField
            label="Община"
            source="municipality"
          />
          <TextField
            label="Квартал"
            source="neighborhood"
          />
        </SimpleShowLayout>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
        lg={4}
      >
        <SimpleShowLayout
          sx={{
            "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
            "& .RaLabeled-label": raLabeledStyle,
          }}
        >
          <TextField
            label="Улица"
            source="street"
          />
          <TextField
            label="Улица номер"
            source="street_number"
          />
        </SimpleShowLayout>
        <SimpleShowLayout
          sx={{
            "& .RaSimpleShowLayout-row": raSimpleShowLayoutCellFlex,
            "& .RaLabeled-label": raLabeledStyle,
            "& .RaSimpleShowLayout-stack": raSimpleShowLayoutFlexRow,
          }}
        >
          <TextField
            label="Бл."
            source="building"
          />
          <TextField
            label="Вх."
            source="entrance"
          />
          <TextField
            label="Ет."
            source="floor"
          />
          <TextField
            label="Ап."
            source="apartment"
          />
        </SimpleShowLayout>
      </Grid>
    </Grid>
  );
};
